import { Component, Input, OnInit } from '@angular/core';
import { Insurance, InsuranceFormValues } from 'src/app/core/models';

@Component({
  selector: 'app-insurance-section',
  templateUrl: './insurance-section.component.html',
  styleUrls: ['./insurance-section.component.scss'],
})
export class InsuranceSectionComponent {
  @Input() title!: string;
  @Input() insurance!: Insurance;
  @Input() updateButtonLabel!: string;
  @Input() formTitle!: string;
  @Input() userData: InsuranceFormValues | null = null;
  @Input() onSubmit: (values: InsuranceFormValues) => void = () => {};

  displayModal: boolean = false;

  constructor() {}

  showModal() {
    this.displayModal = true;
  }

  hideModal() {
    this.displayModal = false;
  }
}
